import React, { useEffect, useState } from "react";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import AuthContent from "widgets/Gift/AuthContent";
import NoAuthContent from "widgets/Gift/NoAuthContent";
import { useParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import { GetNewsApi } from "./api";
import { IGift } from "pages/Gift/api/models";

const News: React.FC = () => {
  const { id } = useParams();
  const { auth_key, user_info } = useAppSelector(userSelect);
  const [cookies] = useCookies(["auth_key", "user_id"]);

  const [gift, setGift] = useState<IGift>();

  const fetchGiftInfo = () => {
    GetNewsApi({ id: Number(id), user_id: user_info?.id || null }).then(
      (res) => {
        const formattedGift: IGift = {
          activate: 0,
          activated_count: 0,
          bonus_left: null,
          bonus_type_id: 0,
          code_type_id: 0,
          id: res.id,
          image: res.gallery[0].url,
          image_extra: null,
          mall_id: res.mall_id,
          mapcode: null,
          mes_to_act: "",
          parking: 0,
          period_from: res.period_from,
          period_to: res.period_till,
          place_id: res.place_id!,
          place_num: "",
          place_title: res.place_title!,
          present_button: 0,
          price: 0,
          show_activated: 0,
          text: res.content,
          title: res.title,
          malls: [],
        };

        setGift(formattedGift);
      }
    );
  };

  useEffect(() => {
    if (cookies.auth_key) {
      user_info && fetchGiftInfo();
      return;
    }

    fetchGiftInfo();
  }, [cookies, user_info]);

  return (
    <main>
      {auth_key && (
        <AuthContent news fetchGiftInfo={fetchGiftInfo} gift={gift} />
      )}
      {!auth_key && <NoAuthContent news gift={gift} />}
    </main>
  );
};

export default News;
